import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import { injectThemeColors } from './config';
import App from './App';

// Inject whitelabel theme colors as CSS custom properties
injectThemeColors();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
